export default "__VITE_ASSET__116583fd__"